import ChatService from '@/services/API/ChatService';
import TelegramService from '@/services/API/TelegramService';
// import ScheduleService from '@/services/API/ScheduleService';

import { TASK_STATUSES } from '@/utils/constants';
import { appChat } from '@/plugins/app-chat';
// import { format } from 'date-fns';
import Base from '../Base';
import Chat from './Chat';

export default class Lesson extends Base {
  constructor(item) {
    super(item.id, '/lessons');
    this.course_id = item.course_id;
    this.course_unit_id = item.course_unit_id;

    this.name = item.name;
    this.description = item.description;
    this.chat_room = item.chat_room;
    this.tasks = item.tasks || [];
    // relativeView = true - вывести прогресс обучающийся стороны, false - свой прогресс
    this.user_passed = item.relativeView ? item.complete_status : item.user_passed;
    this.created_at = item.created_at;

    this.type = item.type; // очный/заочный
    this.conferences = [];

    this.hasConsultationMessages = false;
  }

  async fetchUnread(userId) {
    const tag = {
      course_id: this.course_id,
      course_unit_id: this.course_unit_id,
      lesson_id: this.id,
    };
    const response = await ChatService.getUnreadConsultationsByTag(tag, userId);
    this.hasConsultationMessages = response.data.data;
  }

  async fetchTranslations() {
    const { items } = await TelegramService.conferenceIndex({
      'per-page': 1,
      'search[lesson_id]': this.id,
      'search[im_learning]': true,
    });
    // const jazz = await ScheduleService.index({
    //   'per-page': 1,
    //   'search[lesson]': this.id,
    //   'search[im_learning]': true,
    //   expand: 'lesson,meeting',
    // });

    this.conferences = items;
  }

  isForbidden(lessons) {
    const idx = lessons.indexOf(this);
    return idx !== 0 && lessons[idx - 1].isPassed;
  }

  get tasksPassed() {
    return this.tasks
      .filter((t) => ![
        TASK_STATUSES.retake,
        TASK_STATUSES.notPassed,
        TASK_STATUSES.fail,
      ].includes(t.status));
  }

  get progress() {
    if (!this.tasks.length) return 100;
    return (100 / this.tasks.length) * this.tasksPassed.length;
  }

  get statusColor() {
    return this.user_passed ? 'success' : 'warning lighten-2';
  }

  get isPassed() {
    if (!this.tasks.length && this.user_passed) return false;
    const func = (status) => [
      TASK_STATUSES.retake,
      TASK_STATUSES.notPassed,
      TASK_STATUSES.inProcess,
    ].includes(status);

    return this.tasks.every(
      (t) => (func(t.status)),
    );
  }

  get isComplete() {
    if (this.user_passed) return true;
    if (!this.tasks.length) return true;
    return this.tasks.every(
      (t) => [TASK_STATUSES.done, TASK_STATUSES.success].includes(t.status),
    );
  }

  get isFailed() {
    const statuses = this.tasks.map((i) => i.status);
    return statuses.includes(TASK_STATUSES.fail)
      && !(statuses.includes(TASK_STATUSES.retake)
      || statuses.includes(TASK_STATUSES.notPassed)
      || statuses.includes(TASK_STATUSES.inProcess));
  }

  getMaterialsPath() {
    return {
      name: 'EducationLessonMaterials',
      params: {
        courseId: this.course_id,
        unitId: this.course_unit_id,
        lessonId: this.id,
      },
    };
  }

  async openChatAsStudent() {
    const room = await ChatService.getRoomCourse(this.course_id);
    this.startChat({
      room: room.data.data,
      hideInitials: true,
    });
  }

  async openChatAsTeacher({ replyTo }) {
    this.startChat({
      room: this.chat_room,
      replyTo,
    });
  }

  async startChat({ room, hideInitials, replyTo }) {
    const tag = {
      course_id: this.course_id,
      course_unit_id: this.course_unit_id,
      lesson_id: this.id,
    };
    const chat = new Chat({
      ...room,
      tag,
      hideInitials,
      replyTo,
    });
    appChat.set(chat, {
      opened: true,
      title: 'Консультация по уроку',
      subtitle: this.name,
    });
    this.hasConsultationMessages = false;
  }
}
